import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnEnvService } from '@insight/serenity-env';
import { Observable, timer } from 'rxjs';
import { HttpService } from '../services/http.service';
import { LtbUsageSubmitResponse } from './ltb-usage-response';
import { UsageEventBase } from './models/usageEventBase';
import { SlideOutComponent } from '../shared/components/slide-out/slide-out.component';
import { switchMap, takeWhile, share } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class LtbDataService {

  public currenntSlideOutShown: SlideOutComponent;
  private pollFileStatus$: Observable<[]>;

  constructor(private httpService: HttpService, private envService: SnEnvService) {
    this.pollFileStatus$ = timer(0, 60000).pipe(
      switchMap(() => this.CheckValidationFileExistence()),
      takeWhile(res => {
        return !res.body['status'];
      })
    );
  }

  PostLtbUsage(data: UsageEventBase): Observable<LtbUsageSubmitResponse> {
    const url = this.envService.get('api_url') + 'manualusageevent';
    const body = data;
    return this.httpService.post<LtbUsageSubmitResponse>(url, body);
  }

  GetLtbTemplateFile(): Observable<any> {
    const url = this.envService.get('api_url') + `manualusageevent/template`;
    const httpOption: Object = {
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'arraybuffer'
    };

    return this.httpService.get<any>(url, httpOption);
  }

  PostLtbTemplateFile(formData: FormData): Observable<any> {
    const url = this.envService.get('api_url') + `manualusageevent/template`;
    return this.httpService.post<any>(url, formData);
  }

  GetLtbAccrualFile(): Observable<any> {
    const url = this.envService.get('api_url') + `manualusageevent/accrual`;
    const httpOption: Object = {
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'arraybuffer'
    };

    return this.httpService.get<any>(url, httpOption);
  }

  GetClientUsageProducts(aviId: string, contToken?: string): Observable<any> {
    var url = this.envService.get('api_url')
      + 'billingagreement?filter=clientid:' + aviId + ',feetype:Manual';

    if (contToken) {
      url += '&continuationToken=' + encodeURIComponent(contToken);
    }
    return this.httpService.get<any>(url);
  }

  CheckValidationFileExistence(): Observable<any> {
    const url = this.envService.get('api_url') + 'tract/checkFileStatus';

    return this.httpService.get<any>(url, this.GetHttpOptions(false));
  }

  DownloadValidationFile(): Observable<any> {
    const url = this.envService.get('api_url') + 'tract/downloadFile';

    return this.httpService.get<any>(url, this.GetHttpOptions(true));
  }

  GenerateValidationFile(fileAction: string): Observable<any> {
    const url = this.envService.get('api_url') + 'tract/validation/' + fileAction;

    return this.httpService.get<any>(url, this.GetHttpOptions(false));
  }

  PollForValidationFile(): Observable<any> {
    return this.pollFileStatus$;
  }

  GetClientMappingFile(): Observable<any> {
    const url = this.envService.get('api_url') + 'ClientMapping';
    const httpOption: Object = {
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'arraybuffer'
    };

    return this.httpService.get<any>(url, httpOption);
  }

  private GetHttpOptions(addResponseType: boolean) {
    const httpOption: Object = {
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      ...(addResponseType && { responseType: 'arraybuffer' })
    };

    return httpOption;
  }
}
